import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignInAlt } from "@fortawesome/free-solid-svg-icons";

import { useHistory, Link } from "react-router-dom";

import Input from "../components/common/input/Input";
import LoginButton from "../components/buttons/LoginButton";

import Logo from "../assets/llh-logo.png";
import "./Login.css";

const LoginPage = () => {
  const history = useHistory();

  return (
    <div className="login-page">
      <div className="login-card">
        <form>
          <img src={Logo} alt="company-logo" className="company-logo" />
          <h1 className="authentication-title">AUTHENTICATION</h1>

          <LoginButton />
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
